import type {I18nKey} from "./en";

export const ro: Record<I18nKey, string> = {
  "Search for products...": "Cauta un produs...",
  "Best Sellers": "Cele mai vandute",
  "Shopping cart": "Cos de cumparaturi",
  "My cart": "Cosul meu",
  "Remove all products": "Sterge toate produsele",
  "Wishlist": "Lista de dorinte",
  "Compare products": "Compara produse",
  "You have not added any products to your wishlist. Add one right now!": "Nu ai adaugat niciun produs in lista de dorinte. Adauga unul acum!",
  "You have not added any products to the comparison list. Add one right now!": "Nu ai adaugat niciun produs in lista de comparatie. Adauga unul acum!",
  "Add to cart": "Adauga in cos",
  "Checkout": "Finalizare",
  "Quick checkout": "Cumparare rapida",
  "Go to cart": "Mergi la cos",
  "Back to shopping": "Inapoi la cumparaturi",
  "Home": "Acasa",
  "Price": "Pret",
  "Remove": "Sterge",
  "Sort by": "Sorteaza dupa",
  "Popular": "Popular",
  "Price ascending": "Pret crescator",
  "Price descending": "Pret descrescator",
  "Brand A-Z": "Brand A-Z",
  "Brand Z-A": "Brand Z-A",
  "Name A-Z": "Nume A-Z",
  "Name Z-A": "Nume Z-A",
  "Newest": "Cele mai noi",
  "See more": "Vezi mai multe",
  "Latest products": "Noutati",
  "Results for": "Rezultate pentru",
  "No products found": "Niciun produs gasit",
  "No brands found": "Niciun brand gasit",
  "Product not found": "Produsul nu a fost gasit",
  "Cart update failed": "Actualizarea cosului a esuat",
  "Enter the promotional code": "Introdu codul promotional",
  "Invalid voucher code": "Codul introdus este incorect sau nu este valid pentru aceasta comanda",
  "You cannot use your own influencer voucher": "Nu poti folosi propriul voucher influencer",
  "Voucher applied successfully": "Codul promotional a fost aplicat in cos.",
  "Copy checkout link": "Copiaza link checkout",
  "Link copied": "Link copiat",
  "Discount": "Discount",
  "Subtotal": "Subtotal",
  "Total": "Total",
  "Total (VAT incl.)": "Total (TVA inclus)",
  "Voucher": "Voucher",
  "Voucher not applicable": "Nu ai produse in cos pentru a aplica discountul voucherului adaugat!",
  "Use new address only": "Introdu o adresa noua de livrare",
  "Use saved addresses": "Foloseste adresele salvate",
  "Trade register no.": "Nr. Reg. Com.",
  "Loading products...": "Se incarca produsele...",
  "Your cart is empty": "Cosul tau este gol",
  "Sign in to add items to your cart.": "Autentifica-te pentru a adauga produse in cos.",
  "Free Delivery": "Livrare gratuita",
  "Add another": "Adauga inca",
  "to your shopping bag to get FREE DELIVERY!": "in cos pentru a avea LIVRARE GRATUITA!",
  "Congratulations, you get FREE DELIVERY for this order!": "Felicitari, primesti LIVRARE GRATUITA pentru aceasta comanda!",
  "Congratulations, free shipping!": "Felicitari, livrare gratuita!",
  "All rights reserved.": "Toate drepturile rezervate.",
  "Your name": "Numele tau",
  "Your e-mail address": "Adresa de e-mail",
  "Subscribe": "Abonare",
  "Payment & Delivery": "Plata si livrare",
  "Terms & Conditions": "Termeni si conditii",
  "Privacy Policy": "Politica de confidentialitate",
  "Return Policy": "Politica de retur",
  "Bucharest": "Bucuresti",
  "Special promotions": "Promotii speciale",
  "On a monthly basis": "In fiecare luna",
  "Secure payment": "Plata securizata",
  "With credit / debit card": "Cu cardul online",
  "Free delivery": "Livrare gratuita",
  "For orders above 100 Lei": "Pentru comenzi peste 100 Lei",
  "We are here for you": "Oricand, suntem aici pentru tine",
  "Special Promotions On a monthly basis": "Promotii speciale in fiecare luna",
  "Secure Payment With credit / debit card": "Plata securizata cu card",
  "Free Delivery For orders above 100 Lei": "Livrare gratuita pentru comenzi peste 100 Lei",
  "Contact Us Anytime, we are here for you": "Contacteaza-ne oricand",
  "Log out": "Deconectare",
  "Account": "Cont",
  "Buy now": "Cumpara",
  "EAN": "EAN",
  "Your order": "Comanda ta",
  "Your order has been successfully registered!": "Comanda ta a fost inregistrata cu succes!",
  "You can check the status of the order by accessing": "Poti verifica statusul comenzii accesand",
  "your account": "contul tau",
  "or following your e-mail address.": "sau urmarind adresa de e-mail.",
  "Guest order confirmation hint": "Vei primi actualizari despre comanda la adresa de e-mail furnizata.",
  "Sign in to see price": "Autentifica-te pentru a vedea pretul",
  "Billing information": "Informatii facturare",
  "Name and surname": "Nume si prenume",
  "Phone number": "Numar de telefon",
  "E-mail address": "Adresa de e-mail",
  "Individual": "Persoana fizica",
  "Company": "Persoana juridica",
  "Company name": "Denumire firma",
  "VAT Number": "CUI",
  "Office address": "Sediu social",
  "Bank": "Banca",
  "Bank account": "Cont bancar",
  "Delivery information": "Informatii livrare",
  "Saved addresses": "Adrese salvate",
  "Saved companies": "Firme salvate",
  "New company": "Firma noua",
  "New address": "Adresa noua",
  "Address (street, number)": "Adresa (strada, numar)",
  "County": "Judet",
  "City": "Localitate",
  "Zip code": "Cod postal",
  "Payment method": "Metoda de plata",
  "Cash on delivery": "Ramburs",
  "Credit / Debit card": "Card credit / debit",
  "Leave a message": "Lasa un mesaj",
  "Shipping": "Livrare",
  "Free": "Gratuit",
  "I agree with": "Sunt de acord cu",
  "the terms and conditions": "termenii si conditiile",
  "Please accept the terms and conditions": "Te rugam sa accepti termenii si conditiile",
  "Please select a payment method": "Te rugam sa selectezi o metoda de plata",
  "This field is required": "Acest camp este obligatoriu",
  "Please enter a valid e-mail address": "Te rugam sa introduci o adresa de e-mail valida",
  "Please select an option": "Te rugam sa selectezi o optiune",
  "Please attach a file": "Te rugam sa atasati un fisier",
  "Order is processing...": "Comanda se proceseaza...",
  "Back": "Inapoi",
  "Send order": "Trimite comanda",
  "Place order": "Plaseaza comanda",
  "Order summary": "Rezumat comanda",
  "Shipping address": "Adresa de livrare",
  "Shipping methods": "Metode de livrare",
  "Home delivery": "Livrare la domiciliu",
  "Quantity label": "Cant.",
  "Coupon code": "Cod cupon",
  "Check address to continue": "Verifica datele adresei pentru a continua",
  "Card payment secure hint": "Vei finaliza plata cu cardul in siguranta la pasul urmator.",
  "Checkout trust secure": "Plata SSL securizata",
  "Checkout trust returns": "Retur gratuit 30 zile",
  "Checkout trust local": "Companie romaneasca",
  "Order failed": "Comanda a esuat",
  "Please wait, we are redirecting you to the secure payment page...": "Te rugam sa astepti, redirectionam catre pagina securizata de plata...",
  "We will redirect you to the contact page in": "Vei fi redirectionat catre pagina de contact in",
  "seconds": "secunde",
  "Order payment": "Plata comanda",
  "Payment for the order": "Plata pentru comanda",
  "it was done successfully!": "a fost efectuata cu succes!",
  "We will contact you as soon as possible to confirm the order.": "Te vom contacta cat mai curand pentru confirmarea comenzii.",
  "it was not done successfully!": "nu a fost efectuata cu succes!",
  "Please contact us to fix this issue.": "Te rugam sa ne contactezi pentru a rezolva aceasta problema.",
  "Contact us": "Contacteaza-ne",
  "Payment is being processed!": "Plata este in curs de procesare!",
  "Thank you, payment for the order": "Multumim, plata pentru comanda",
  "is in processing.": "este in procesare.",
  "Member since": "Membru din",
  "Orders": "Comenzi",
  "Returns": "Retururi",
  "Profile": "Profil",
  "Your network": "Reteaua ta",
  "Influencer": "Influencer",
  "Addresses": "Adrese",
  "Notifications": "Notificari",
  "Influencer dashboard": "Dashboard influencer",
  "Influencer access is not enabled for this account.": "Accesul influencer nu este activat pentru acest cont.",
  "Create codes, track commissions, and request payouts.": "Creeaza coduri, urmareste comisioanele si cere retrageri.",
  "Pick categories or brands with the same commission percent.": "Alege categorii sau branduri cu acelasi procent de comision.",
  "Codes you generated for your audience.": "Codurile pe care le-ai generat pentru audienta ta.",
  "Orders that earned you commission.": "Comenzile care ti-au adus comision.",
  "Search categories and brands...": "Cauta categorii si branduri...",
  "Search brands...": "Cauta branduri...",
  "Expand to pick subcategories": "Deschide pentru subcategorii",
  "Browse or search brands": "Rastoara sau cauta branduri",
  "Selection summary": "Rezumat selectie",
  "You chose": "Ai ales",
  "brand": "brand",
  "category": "categorie",
  "no brands": "niciun brand",
  "no categories": "nicio categorie",
  "offering": "oferi",
  "discount": "discount",
  "Select categories and/or brands below, then generate your voucher.": "Selecteaza categorii si/sau branduri, apoi genereaza voucherul.",
  "No matching scopes": "Nicio categorie sau brand gasit",
  "scopes selected": "selectate",
  "Other": "Altele",
  "Categories": "Categorii",
  "No influencer vouchers yet": "Inca nu ai vouchere influencer",
  "Voucher code": "Cod voucher",
  "Commission": "Comision",
  "Validity": "Valabilitate",
  "Applies to": "Se aplica la",
  "from": "de la",
  "to": "pana la",
  "days remaining": "zile ramase",
  "1 day remaining": "1 zi ramasa",
  "Expired": "Expirat",
  "scope": "selectie",
  "scopes": "selectii",
  "days": "zile",
  "Total generated": "Total generat",
  "Available for payout": "Disponibil retragere",
  "Pending payout": "In asteptare",
  "Paid out": "Platit",
  "Generate influencer voucher": "Genereaza voucher influencer",
  "Validity (days)": "Valabilitate (zile)",
  "You can only combine scopes with the same percent. For a different percent, generate a separate voucher.": "Poti combina doar scope-uri cu acelasi procent. Pentru alt procent, genereaza un voucher separat.",
  "Request payout": "Cere retragere",
  "Payment details (IBAN, etc.)": "Detalii plata (IBAN etc.)",
  "Your influencer vouchers": "Voucherele tale influencer",
  "Commission orders": "Comenzi cu comision",
  "No influencer earnings yet": "Inca nu ai comisioane",
  "Select scopes": "Selecteaza scope-uri",
  "You have not placed any orders on our site yet.": "Nu ai plasat inca nicio comanda pe site-ul nostru.",
  "Order": "Comanda",
  "Pay with Credit / Debit Card": "Plateste cu cardul",
  "Download order": "Descarca comanda",
  "Return this order": "Returneaza aceasta comanda",
  "Order information": "Informatii comanda",
  "Online payment": "Plata online",
  "Address": "Adresa",
  "Products": "Produse",
  "You have not placed any return requests on our site yet.": "Nu ai plasat inca nicio cerere de retur pe site-ul nostru.",
  "Return": "Retur",
  "Return information": "Informatii retur",
  "Order date": "Data comenzii",
  "Return motive": "Motiv retur",
  "Bank details": "Date bancare",
  "The desired solution": "Solutia dorita",
  "Saved!": "Salvat!",
  "Saving...": "Se salveaza...",
  "Copied!": "Copiat!",
  "Copy code": "Copiaza codul",
  "Save": "Salveaza",
  "Change account password.": "Schimba parola contului.",
  "New password": "Parola noua",
  "Retype the new password": "Reintrodu parola noua",
  "The two passwords are different.": "Cele doua parole sunt diferite.",
  "Change": "Schimba",
  "Enjoy a": "Bucura-te de un comision de",
  "commission on every order generated by your network": "la fiecare comanda generata de reteaua ta",
  "Your access code for your network": "Codul tau de acces pentru retea",
  "Your comission": "Comisionul tau",
  "Registration date": "Data inregistrarii",
  "Unlock the full potential of your network by expanding your connections!": "Dezvolta-ti reteaua pentru a debloca potentialul complet!",
  "Your benefits": "Beneficiile tale",
  "Generate voucher": "Genereaza voucher",
  "Voucher code:": "Cod voucher:",
  "Value": "Valoare",
  "Valability": "Valabilitate",
  "Used / Expired": "Folosit / Expirat",
  "Add the delivery and billing addresses. When placing a new order, you will be able to select one of these addresses.": "Adauga adresele de livrare si facturare. La plasarea unei comenzi noi vei putea selecta una dintre aceste adrese.",
  "Address name (for future use)": "Nume adresa (pentru utilizare viitoare)",
  "Choose county": "Alege judetul",
  "Add the new address": "Adauga adresa noua",
  "Save modifications": "Salveaza modificarile",
  "Edit address": "Modifica adresa",
  "Edit company": "Modifica firma",
  "Personal information": "Date personale",
  "Password & security": "Parola si securitate",
  "Show password": "Arata parola",
  "Hide password": "Ascunde parola",
  "Weak password": "Parola slaba",
  "Fair password": "Parola acceptabila",
  "Good password": "Parola buna",
  "Strong password": "Parola puternica",
  "Add company": "Adauga firma",
  "No saved addresses yet": "Nu ai adrese salvate inca",
  "No billing companies yet": "Nu ai firme de facturare salvate inca",
  "Delete this company": "Sterge aceasta firma",
  "Close": "Inchide",
  "Delete this address": "Sterge aceasta adresa",
  "You have not set any stock alerts.": "Nu ai setat nicio alerta de stoc.",
  "Out of stock": "Stoc epuizat",
  "Work program": "Program de lucru",
  "Monday-Friday, between 9.00 and 17.30 (except for public holidays)": "Luni-Vineri, intre 9.00 si 17.30 (cu exceptia sarbatorilor legale)",
  "Name": "Nume",
  "Message": "Mesaj",
  "Message was sent!": "Mesajul a fost trimis!",
  "Send": "Trimite",
  "Send failed": "Trimiterea a esuat",
  "Product return form": "Formular retur produse",
  "I want to return the order in full or in parts": "Doresc sa returnez comanda integral sau partial",
  "I would like to return the following products": "Doresc sa returnez urmatoarele produse",
  "The reason for the return is": "Motivul returului este",
  "My return options are": "Optiunile mele de retur sunt",
  "I want to replace the product with a new one": "Doresc inlocuirea produsului cu unul nou",
  "I want to replace it with another product": "Doresc inlocuirea cu alt produs",
  "I want to receive cash value": "Doresc contravaloarea in bani",
  "Images with the product (s)": "Imagini cu produsul/produsele",
  "I agree to this notification form regarding my withdrawal from the contract": "Sunt de acord cu acest formular de notificare privind retragerea din contract",
  "Please accept the terms": "Te rugam sa accepti termenii",
  "Select at least one product": "Selecteaza cel putin un produs",
  "Brands": "Branduri",
  "Discover premium brands": "Descopera branduri premium",
  "Fresh picks by category": "Noutati pe categorii",
  "Top sellers by category": "Cele mai vandute pe categorii",
  "categories": "categorii",
  "products in stock": "produse in stoc",
  "View products": "Vezi produse",
  "Newsletter unsubscribe": "Dezabonare newsletter",
  "You have been successfully unsubscribed from our newsletter.": "Ai fost dezabonat cu succes de la newsletterul nostru.",
  "Unsubscribe could not be completed.": "Dezabonarea nu a putut fi efectuata.",
  "Please contact us for assistance.": "Te rugam sa ne contactezi pentru asistenta.",
  "Subscribed successfully!": "Abonare reusita!",
  "Notify me when back in stock": "Anunta-ma cand revine in stoc",
  "Notify me": "Anunta-ma",
  "Notification saved": "Notificarea a fost salvata",
  "General": "General",
  "Payments": "Plati",
  "Delivery": "Livrare",
  "Support": "Suport",
  "More products": "Mai multe produse",
  "LIMITED TIME DISCOUNTS": "REDUCERI LIMITATE IN TIMP",
  "See all": "Vezi toate",
  "products": "produse",
  "brands": "branduri",
  "FILTER PRODUCTS": "FILTREAZA PRODUSELE",
  "Filter": "Filtru",
  "Clear filters": "Sterge filtrele",
  "CATEGORIES": "CATEGORII",
  "Departments": "Departamente",
  "Main navigation": "Navigare principala",
  "Carousel navigation": "Navigare carusel",
  "Search departments categories...": "Cauta in categoriile Beauty...",
  "Beauty hub link": "Exploreaza hub-ul Beauty",
  "Search categories...": "Cauta categorii...",
  "No categories found": "Nicio categorie gasita",
  "Search for brand...": "Cauta brand...",
  "PRICE": "PRET",
  "Price range": "Interval pret",
  "Min": "Min",
  "Max": "Max",
  "Apply price": "Aplica",
  "Load more": "Incarca mai multe",
  "Load more products": "Incarca mai multe produse",
  "View more": "Vezi mai multe",
  "View less": "Vezi mai putine",
  "All products": "Toate produsele",
  "The page you are looking for was not found": "Pagina pe care o cauti nu a fost gasita",
  "Campaign": "Campanie",
  "Campaign page is not available yet.": "Pagina de campanie nu este disponibila inca.",
  "FAQ": "FAQ",
  "FAQ page subtitle": "Răspunsuri la cele mai frecvente întrebări despre comenzi, livrare și retururi.",
  "Still have questions?": "Mai ai întrebări?",
  "FAQ contact hint": "Echipa noastră te poate ajuta personal.",
  "Use voucher": "Foloseste voucher",
  "Log in": "Autentificare",
  "Create account": "Creare cont",
  "Invite code": "Cod invitatie",
  "First name": "Prenume",
  "Last name": "Nume",
  "Phone": "Telefon",
  "Password": "Parola",
  "With regards from": "Cu salutari din partea",
  "Please fill in the details required and prepare yourself for an amazing shopping experience!": "Te rugam sa completezi datele necesare si sa te pregatesti pentru o experienta de cumparaturi de neuitat!",
  "The code used is not valid!": "Codul folosit nu este valid!",
  "Login failed": "Autentificare esuata",
  "Registration failed": "Inregistrare esuata",
  "Network size": "Marime retea",
  "Network total orders": "Total comenzi retea",
  "Total revenue": "Venit total",
  "Total vouchers": "Total vouchere",
  "Unclaimed revenue": "Venit neincasat",
  "New products": "Produse noi",
  "Free shipping": "Transport gratuit",
  "Recover password": "Recuperare parola",
  "Welcome back": "Bine ai revenit",
  "New here": "Esti nou",
  "Sign in to continue shopping": "Autentifica-te pentru a continua cumparaturile",
  "Enter your email and captcha to receive a new password.": "Introdu emailul si captcha pentru a primi o parola noua.",
  "Reset password": "Reseteaza parola",
  "The sum of": "Suma dintre",
  "The result is...": "Rezultatul este...",
  "The new password has been sent by e-mail!": "Noua parola a fost trimisa pe e-mail!",
  "Wrong email address!": "Adresa de e-mail gresita!",
  "Review the product": "Recenzieaza produsul",
  "Your review": "Recenzia ta",
  "There are no reviews for this product yet. You can be the first!": "Nu exista inca recenzii pentru acest produs. Poti fi primul!",
  "The review has been sent!": "Recenzia a fost trimisa!",
  "The result is incorrect.": "Rezultatul este incorect.",
  "Send review": "Trimite recenzia",
  "Phone (optional)": "Telefon (optional)",
  "Cancel notification": "Anuleaza notificarea",
  "Billing companies": "Firme facturare",
  "The company has been successfully added.": "Firma a fost adaugata cu succes.",
  "Delete member": "Sterge membru",
  "Stars": "Stele",
  "Reviews": "Recenzii",
  "Description": "Descriere",
  "How to use": "Mod de utilizare",
  "Brand": "Brand",
  "Category": "Categorie",
  "Gender": "Gen",
  "Size": "Mărime",
  "Product details": "Detalii produs",
  "in cart": "in cos",
  "Added to cart": "Adaugat in cos",
  "Unit price": "Pret unitar",
  "Line total": "Total produs",
  "Cart total": "Total cos",
  "Qty": "Cant.",
  "Incorrect captcha": "Captcha incorect",
  "The product has been added to cart": "Produsul a fost adaugat in cos",
  "This site uses cookies. By continuing to browse this site, you agree to the use of cookies.": "Acest site foloseste cookie-uri. Prin continuarea navigarii pe acest site va exprimati acordul asupra folosirii cookie-urilor.",
  "More details...": "Mai multe detalii...",
  "Discounts": "Reduceri",
  "New": "Nou",
  "Menu": "Meniu",
  "Special order request": "Comanda speciala",
  "Product name": "Nume produs",
  "Product code": "Cod produs",
  "Request sent!": "Cererea a fost trimisa!",
  "View all results": "Vezi toate rezultatele",
  "Suggested categories": "Categorii sugerate",
  "Start typing to search": "Incepe sa scrii pentru a cauta branduri, categorii sau produse",
  "Recent searches": "Cautari recente",
  "Leave search for category?": "Parasesti cautarea pentru categorie?",
  "You are about to leave search and open the category page. Continue?": "Cautarea se va inchide si vei deschide pagina categoriei. Continui?",
  "Open category page": "Deschide pagina categoriei",
  "Cancel": "Anuleaza",
  "Clear category filter": "Sterge filtrul de categorie",
  "Subcategory": "Subcategorie",
  "Sub-subcategory": "Sub-subcategorie",
  "Sub-sub-subcategory": "Sub-sub-subcategorie",
  "Close search": "Inchide cautarea",
  "Previous": "Inapoi",
  "Next": "Inainte",
  "Back to top": "Inapoi sus",
  "Search results": "Rezultate cautare",
  "Back to orders": "Inapoi la comenzi",
  "View order details": "Vezi detaliile comenzii",
  "Compare": "Compara",
  "In comparison": "In comparatie",
  "Price alert": "Alerta pret",
  "About the brand:": "Despre brand:",
  "Product variants": "Variante produs",
  "Delivery & Returns": "Livrare & Retur",
  "Search product variants...": "Cauta o varianta...",
  "Show all": "Mai multe",
  "Recommended products": "Produse recomandate",
  "RECENTLY VIEWED": "VIZUALIZATE RECENT",
  "More from": "Mai mult de la",
  "Professional Salon Supply": "Aprovizionare Profesionala Salon",
  "Duty Free Supply": "Aprovizionare Duty Free",
  "Premium Brands": "Branduri premium",
  "Over 20 000 products": "Peste 20.000 de produse",
  "Genuine products": "Produse originale",
  "Traceable official sources": "Surse verificate oficial",
  "Our Support": "Suportul nostru",
  "Standard delivery": "Livrare standard",
  "Delivery in Romania": "Livrare în România",
  "from 14.90 lei": "de la 14,90 lei",
  "Free shipping title": "Livrare gratuită",
  "over 100 lei": "peste 100 lei",
  "Need help?": "Ai nevoie de ajutor?",
  "Call now": "Sună acum",
  "Footer concierge": "Concierge",
  "Footer store": "Magazin",
  "Footer account": "Cont",
  "Footer information": "Informații",
  "Footer tagline": "Beauty, wellness & lifestyle premium",
  "Footer newsletter title": "Oferte exclusive si promotii speciale",
  "Footer newsletter subtitle": "Aboneaza-te si primesti reduceri dedicate, noutati si campanii surpriza — direct in inbox.",
  "Footer newsletter placeholder": "client@email.ro",
  "Footer newsletter cta": "Primeste oferte exclusive",
  "Footer newsletter disclaimer": "Prin abonare, accepti sa primesti comunicari comerciale si",
  "Footer newsletter promo title": "Livrare rapida",
  "Footer newsletter promo text": "Gratuit de la 100 lei",
  "Footer value free shipping": "Livrare gratuita peste 100 lei",
  "Footer value products": "Peste 20.000 produse selectate",
  "Footer value trusted": "Branduri europene de incredere",
  "Footer value secure payment": "Plata securizata",
  "Footer about heading": "Despre Zaaaz",
  "Footer info heading": "Informatii si contact",
  "Footer shops heading": "Magazin",
  "Footer brand description": "Zaaaz este magazinul premium B2B2C pentru beauty, wellness si lifestyle — preturi exclusive pentru membri si livrare rapida in Romania.",
  "Footer customer service": "Serviciu clienti",
  "Email already subscribed": "Aceasta adresa este deja abonata",
  "Payment methods": "Metode de plata",
  "SameDay estimated delivery": "Estimare livrare SameDay",
  "Estimated delivery": "Livrare estimată",
  "Expected delivery": "Livrare estimata",
  "Available": "Disponibil",
  "Special offer": "Oferta speciala",
  "Characteristics": "Caracteristici",
  "Delivery and returns": "Livrare si retur",
  "REF": "REF",
  "Coming soon...": "In curand...",
  "Fast delivery": "Livrare rapida",
  "B2B discounts": "Discount B2B",
  "Exclusive prices for members": "Preturi exclusive pentru membri",
  "Welcome to Zaaaz": "Bun venit la Zaaaz",
  "Discover premium beauty and wellness products for your company, with exclusive B2B discounts and fast delivery across Romania.": "Descopera produse premium beauty si wellness pentru compania ta, cu discounturi B2B exclusive si livrare rapida in Romania.",
  "Why shop with Zaaaz": "De ce sa cumperi de la Zaaaz",
  "All categories": "Toate categoriile",
  "Card or cash on delivery": "Card sau ramburs la livrare",
  "Estimated delivery on every product": "Livrare estimata pe fiecare produs",
  "SameDay": "SameDay",
  "Free returns": "Retur gratuit",
  "30 days, risk-free": "30 de zile, fără griji",
  "Free shipping over 100 lei": "Livrare gratuită peste 100 lei",
  "For orders <br /> above 100 lei": "Pentru comenzi <br /> peste 100 lei",
  "This product is a tester and it might be shipped unboxed.": "Acest produs este un tester si poate fi livrat fara cutie.",
  "Stock notification": "Alerta stoc",
  "You have an active stock notification for this product!": "Ai o alerta de stoc activa pentru acest produs!",
  "Be the first to find out when it returns to stock!": "Fii primul care afla cand revine in stoc!",
  "<b>30 days</b> free return": "<b>30 zile</b> retur gratuit",
  "The product has been added to cart!": "Produsul a fost adaugat in cos!",
  "Click here to go to your shopping cart": "Click aici pentru a merge la cosul de cumparaturi",
  "ALERTA DE PRET": "ALERTA DE PRET",
  "Set price alert": "Seteaza alerta!",
  "I want to be notified if the price drops below": "Doresc notificare daca pretul scade sub",
  "Lei": "Lei",
  "You save": "Economisești",
  "SKU": "SKU",
  "ID #": "ID",
  "I also want to subscribe to the newsletter": "Doresc sa ma abonez si la newsletter",
  "Current product price is": "Pretul curent al produsului este de",
  "Language": "Limba",
  "Currency": "Valuta",
  "EUR": "EUR",
  "Carousel hero promo eyebrow": "Timp limitat",
  "Carousel hero promo title": "Oferte Speciale",
  "Carousel hero promo subtitle": "Reduceri B2B exclusive la branduri beauty si wellness — economisesti la fiecare comanda",
  "Carousel hero promo cta": "Vezi promotiile",
  "Carousel hero delivery eyebrow": "Livrare rapida",
  "Carousel hero delivery title": "Livrare Rapida",
  "Carousel hero delivery subtitle": "SameDay si livrare nationala in Romania — transport gratuit la comenzi eligibile",
  "Carousel hero delivery cta": "Info transport gratuit",
  "Carousel hero brands eyebrow": "Branduri de incredere",
  "Carousel hero brands title": "Produse 100% Originale",
  "Carousel hero brands subtitle": "Branduri premium din surse oficiale — peste 20.000 de produse",
  "Carousel hero brands cta": "Descopera brandurile",
  "Home departments title": "Cumpara pe departamente",
  "Home departments subtitle": "Incepe cu Beauty — urmeaza alte departamente in curand pe Zaaaz",
  "Home department beauty title": "Beauty",
  "Home department beauty description": "Parfumuri, machiaj, ingrijirea pielii, par si multe altele — totul intr-un singur loc",
  "Home department beauty card description": "Parfumuri, machiaj, produse de baie si multe altele. Descopera intreaga gama beauty.",
  "Home department fashion card description": "Imbracaminte si accesorii pentru echipe si cadouri corporate — in curand.",
  "Home department home card description": "Decoratiuni, bucatarie si produse lifestyle pentru birouri moderne.",
  "Home department electronics card description": "Gadget-uri si electronice pentru business si beneficii angajati.",
  "Home department sports card description": "Echipament sportiv si produse pentru un stil de viata activ.",
  "Home department food card description": "Produse gourmet si bauturi pentru evenimente si cadouri corporate.",
  "Home department baby card description": "Ingrijire bebelusi si produse pentru copii in beneficiile familiei.",
  "Home department pets card description": "Produse pentru animale de companie — pentru angajatii pasionati.",
  "Home department office card description": "Rechizite si esentiale pentru orice spatiu de lucru.",
  "Home department automotive card description": "Accesorii auto si produse de ingrijire masina.",
  "Home department garden card description": "Gradina si outdoor pentru spatii verzi si relaxare.",
  "Beauty hub intro": "Destinatia ta dedicata pentru beauty si wellness premium — branduri autentice, preturi B2B si livrare rapida in Romania.",
  "Beauty hub categories title": "Exploreaza categoriile beauty",
  "Department hub all departments": "Toate departamentele",
  "Department hub current": "Curent",
  "Home department fashion title": "Fashion",
  "Home department home title": "Home & Living",
  "Home department electronics title": "Electronice",
  "Home department sports title": "Sport",
  "Home department food title": "Food & Gourmet",
  "Home department baby title": "Baby & Kids",
  "Home department pets title": "Pet Care",
  "Home department office title": "Office",
  "Home department automotive title": "Auto",
  "Home department garden title": "Gradina & Outdoor",
  "Home departments coming soon": "In curand",
  "Home department view cta": "Vezi departamentul",
  "Home promo tabs title": "De ce Zaaaz",
  "Home promo tabs tab store": "Magazin multi-departament cu zeci de mii de produse",
  "Home promo tabs tab delivery": "Livrare rapida direct din stoc",
  "Home promo tabs tab quality": "Calitate garantata, de fiecare data",
  "Home promo tabs body store": "Zaaaz aduce la un loc parfumuri premium, machiaj si ingrijirea pielii. De la parfumuri de designer la cosmetice profesionale — descopera departamentul Beauty cu branduri autentice si preturi B2B.",
  "Home promo tabs body delivery": "Comanda parfumuri si machiaj azi si primeste-le rapid din depozitul nostru. Majoritatea comenzilor Beauty pleaca in 24–48 de ore in toata Romania, cu stoc trasabil in care poti avea incredere.",
  "Home promo tabs body quality": "Fiecare parfum si produs de machiaj provine de la distribuitori oficiali. Garantam autenticitate, trasabilitate completa si preturi B2B competitive pentru cumparatorii corporate.",
  "Home promo tabs link beauty": "Exploreaza departamentul Beauty",
  "Home promo tabs link fragrance": "Cumpara parfumuri",
  "Home promo tabs link makeup": "Cumpara machiaj",
  "Carousel hero fragrance eyebrow": "Selectia parfumuri",
  "Carousel hero fragrance title": "Arome de Semnatura",
  "Carousel hero fragrance subtitle": "Esente rare si parfumuri iconice pentru o prezenta care ramane",
  "Carousel hero fragrance cta": "Descopera parfumuri",
  "Home perfume spotlight title": "Parfumuri de semnatura pentru fiecare moment",
  "Home perfume spotlight feature 1 title": "Parfumuri iconice de designer",
  "Home perfume spotlight feature 1 body": "Apa de parfum si extract de la case precum Lalique, Parfums de Marly si Histoires de Parfums.",
  "Home perfume spotlight feature 2 title": "Produse 100% originale",
  "Home perfume spotlight feature 2 body": "Fiecare sticla provine din canale oficiale de distributie, cu stoc trasabil si preturi B2B.",
  "Home perfume spotlight feature 3 title": "Livrare rapida in toata Romania",
  "Home perfume spotlight feature 3 body": "Comanda azi si primeste parfumul rapid, cu transport gratuit la comenzi eligibile.",
  "Home brands marquee title": "Brandurile noastre",
  "Home brands marquee cta": "Vezi toate brandurile",
  "Carousel hero makeup eyebrow": "Selectia beauty",
  "Carousel hero makeup title": "Arta Machiajului",
  "Carousel hero makeup subtitle": "Culoare editoriala, texturi rafinate si iconuri ale frumusetii moderne",
  "Carousel hero makeup cta": "Descopera machiajul",
  "Carousel hero hair eyebrow": "Selectia par",
  "Carousel hero hair title": "Ritualuri de Salon",
  "Carousel hero hair subtitle": "Ingrijire si styling profesional pentru un par care respira lux discret",
  "Carousel hero hair cta": "Descopera ingrijirea parului",
  "Volume": "Volum",
  "Tester": "Tester",
  "Sample": "Mostra",
  "Damaged": "Deteriorat"
};
